/* components/patterns/NavLink.jsx — пункт навигации (иконка + подпись + бейдж).
   Обёртка над RR.NavLink с активным состоянием через data-active. */

import { Icon } from '../ui/Icon.jsx';
import { RR } from '../../lib/router.jsx';

  const { NavLink: RRNavLink } = RR;

  function NavItem({ to, icon, label, badge, end, collapsed, onClick, ...rest }) {
    return (
      <RRNavLink to={to} end={end} onClick={onClick} {...rest}
        className={({ isActive }) => 'nav-link' + (isActive ? ' is-active' : '')}>
        <span className="nav-link__icon"><Icon name={icon} size={20} /></span>
        <span className="nav-link__label grow">{label}</span>
        {badge != null && badge > 0 && <span className="nav-link__badge num">{badge}</span>}
      </RRNavLink>
    );
  }

export { NavItem };
